import { render, staticRenderFns } from "./dialogNoticeSort.vue?vue&type=template&id=2d4cad03&scoped=true"
import script from "./dialogNoticeSort.vue?vue&type=script&lang=js"
export * from "./dialogNoticeSort.vue?vue&type=script&lang=js"
import style0 from "./dialogNoticeSort.vue?vue&type=style&index=0&id=2d4cad03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4cad03",
  null
  
)

export default component.exports